<template>
    <div class="notes">
        <div class="info">
            <h3 class="bullet01">在医疗检查的前一天</h3>
            <p class="bullet03 depth">您应该避免过量饮酒或过度劳累.</p>
            <p class="bullet03 depth">我们建议您放松并充足睡眠. 请提前填写调查表，医疗检查时随身携带.</p>

            <h4 class="bullet02 depth">空腹</h4>
            <p class="bullet03 depth">晚上7点前吃一顿清淡的晚餐.</p>
            <p class="bullet03 depth">晚上9点以后您不应该吃任何东西(包括水、口香糖或香烟).</p>

            <h4 class="bullet02 depth">粪便样本</h4>
            <p class="bullet03 depth">如有可能，在体检前一天采集大便样本</p>
            <p class="bullet03 depth">如果您已安排结肠镜检查，我们将为您提供单独的指南，详细说明饮食注意事项和肠道清洁剂的服用方法.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">在检查当天</h3>
            <p class="bullet03 depth">检查当天必须避免吃早餐、抽烟、吃口香糖等</p>
            <p class="bullet03 depth">来就诊时，请随身携带调查表、粪便取样容器、眼镜或隐形眼镜.</p>
            <p class="bullet03 depth">尿液检查也包括在检查清单中，所以请在来到接待处后提供尿样.</p>

            <h4 class="bullet02 depth">药物</h4>
            <p class="bullet03 depth">血压药物、抗惊厥药： 医疗检查当天早上(早上6点左右)喝一小口水.</p>
            <p class="bullet03 depth">糖尿病药物治疗(包括胰岛素注射)：禁食开始之后，应停止胰岛素注射或服用任何糖尿病药物.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">其他事项</h3>
            <p class="bullet03 depth">请不要随身携带贵重物品.</p>
            <p class="bullet03 depth">育龄妇女应在医疗检查前确认其怀孕状态.</p>
            <p class="bullet03 depth">我们建议女性患者在经期之外进行体检；已经接受过子宫切除术治疗的女性还应接受妇科检查，以检查盆腔内器官是否有任何异常</p>
            <p class="bullet03 depth">抗凝剂可能导致内窥镜活检或息肉切除术中出血；接受抗凝血剂 (如阿司匹林) 治疗的患者必须咨询处方医生，最迟在检查前一周确认是否继续或暂停用药，并在检查当天通知我们</p>
            <p class="bullet03 depth">如果您要接受清醒镇静内窥镜检查，请由监护人陪同，并注意，检查之后，当天不允许您开车.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">禁止物质</h3>
            <p class="bullet03 depth">如果在任何检验中使用了造影剂，则在检查后的48小时之内禁止服用二甲双胍类糖尿病药物(例如，Diabex、Janumet、Glupa、Trajenta-duo、Amaryl-M).</p>
            <p class="bullet03 depth">A抗血栓药物和抗凝剂可能导致内窥镜活检或息肉切除术中出血；使用抗血栓药物或抗凝血药物的患者必须咨询处方医生，最迟在检查前一周检查是否继续或暂停给药，并在检查当天通知我们.</p>

            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_01.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_02.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_03.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_04.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_05.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
            </ul>
        </div>

        <div class="info">
            <h4 class="bullet02">抗血栓药实例</h4>
            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_06.jpg" alt=""></div>
                    <div class="tit">Aspirin Protect Tab</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_07.jpg" alt=""></div>
                    <div class="tit">Astrix</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_08.jpg" alt=""></div>
                    <div class="tit">Plavix</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_09.jpg" alt=""></div>
                    <div class="tit">Pletaal Tab</div>
                </li>
            </ul>
        </div>

        <div class="info">
            <h4 class="bullet02">抗凝剂的例子</h4>
            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_10.jpg" alt=""></div>
                    <div class="tit">Warfarin</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_11.jpg" alt=""></div>
                    <div class="tit">Paradaxa</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_12.jpg" alt=""></div>
                    <div class="tit">Xarelto</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_13.jpg" alt=""></div>
                    <div class="tit">Eliquis</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_14.jpg" alt=""></div>
                    <div class="tit">Lixiana</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>